import { ComponentDesign, ModelCategory } from '@paragon/contract-library';
import {
  AdditionalLoadsSchema,
  AnalogModelSchema,
  BearingSchema,
  BraceSchema,
  CarriedComponentsSchema,
  ComponentDesignSchema,
  DataRow,
  DimensionSchema,
  EndConditionSchema,
  GussetSchema,
  HangerSchema,
  isDataRow,
  LoadCaseSchema,
  MemberSchema,
  ModelSchema,
  PlatePairSchema,
  ReferenceLineSchema,
  Row,
  SpliceSchema,
  TrussEnvelopeSchema,
} from '@paragon/layout-models';

export function isComponentDesignRow(row: Row): row is DataRow<ComponentDesign> {
  return (
    isDataRow(row) &&
    (row.type === 'componentDesign' || row.type === 'profileTrussDesign' || row.type === 'featurePatternTrussDesign')
  );
}

export const CustomProfileTrussDesignSchema = new ModelSchema<ComponentDesign>('profileTrussDesign', {
  displayName: (componentDesign) => componentDesign.component.name,
  pluralName: 'Components',
  category: ModelCategory.ComponentDesign,
  properties: {},
  children: {
    splices: SpliceSchema,
    members: MemberSchema,
    braces: BraceSchema,
    gussets: GussetSchema,
    platePairs: PlatePairSchema,
    bearings: BearingSchema,
    referenceLines: ReferenceLineSchema,
    analogModel: AnalogModelSchema,
    additionalLoads: AdditionalLoadsSchema,
    loadCases: LoadCaseSchema,
    dimensions: DimensionSchema,
    jackGirderConnections: CarriedComponentsSchema,
    hangers: HangerSchema,
    trussEnvelopes: TrussEnvelopeSchema,
  },
});

export const CustomFeaturePatternTrussDesignSchema = new ModelSchema<ComponentDesign>('featurePatternTrussDesign', {
  displayName: (componentDesign) => componentDesign.component.name,
  pluralName: 'Components',
  category: ModelCategory.ComponentDesign,
  properties: {},
  children: {
    splices: SpliceSchema,
    members: MemberSchema,
    braces: BraceSchema,
    gussets: GussetSchema,
    platePairs: PlatePairSchema,
    bearings: BearingSchema,
    referenceLines: ReferenceLineSchema,
    endConditions: EndConditionSchema,
    analogModel: AnalogModelSchema,
    additionalLoads: AdditionalLoadsSchema,
    loadCases: LoadCaseSchema,
    dimensions: DimensionSchema,
    jackGirderConnections: CarriedComponentsSchema,
    hangers: HangerSchema,
    trussEnvelopes: TrussEnvelopeSchema,
  },
});

export function getSchemaForComponentDesign(componentDesign: ComponentDesign & { type: string }) {
  switch (componentDesign.type) {
    case 'profileTrussDesign':
      return CustomProfileTrussDesignSchema;
    case 'featurePatternTrussDesign':
      return CustomFeaturePatternTrussDesignSchema;
    case 'componentDesign':
      return ComponentDesignSchema;
    default:
      throw new Error(`Unknown component design type: ${componentDesign.type}`);
  }
}
